import React, {Fragment} from "react";
import {Col, Input} from "reactstrap";
import SFXButtonComponent from "../SFXButtonComponent";
import ChatConversationService from "../../services/chat/ChatConversationService";
import ToastHelper from "../../utils/ToastHelper";
import UserSessionService from "../../services/UserSessionService";
import ChatUserService from "../../services/chat/ChatUserService";
import LoadingSpinnerComponent from "../LoadingSpinnerComponent";
import ChatConversationCreateRequestDTO from "../../domain/Chat/ChatConversationCreateRequestDTO";
import {withRouter} from "react-router";

class CreateChatComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            gotChatUser: false,
            message: ''
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let newState = {isLoading: false};
        newState.apiUser = UserSessionService.getUser().user;

        let initialPromises = [];
        let chatUserIndex = initialPromises.length;
        initialPromises[chatUserIndex] = ChatUserService.retrieve(newState.apiUser.id);

        Promise.all(initialPromises).then(
            initialResponses => {
                if (initialResponses[chatUserIndex].id) {
                    newState.gotChatUser = true;
                    newState.chatUser = initialResponses[chatUserIndex];
                } else {
                    ToastHelper.formatError(initialResponses[chatUserIndex])
                }
                this.setState(newState)
            }
        );

    }

    onMessageChange(event) {
        this.setState({
            message: event.target.value
        });
    }

    onCreateConversation() {
        this.setState({isLoading: true})

        let request = ChatConversationCreateRequestDTO.toJson(this.state.chatUser.id, this.state.message, this.props.context)

        ChatConversationService.createConversation(request).then(
            response => {
                if (!response.id) {
                    ToastHelper.formatError(response)
                }else{
                    ToastHelper.success("Conversation has been started")
                    this.setState({isModalOpen: false});
                    let url = '/chat/'+response.id
                    this.props.history.push(url);
                }
            }
        );
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingSpinnerComponent/>
        }

        return <Fragment>
            <Col>
                Enter message
                <Input type={'textarea'}
                       onChange={this.onMessageChange.bind(this)}
                       placeholder={'Message ...'}
                />
                <br/>
                <SFXButtonComponent
                    className={"btn-primary"}
                    style={{width: '100%'}}
                    onClick={this.onCreateConversation.bind(this)}
                    disabled={this.state.message === ''}
                >
                    Start Conversation
                </SFXButtonComponent>
            </Col>
        </Fragment>
    }
}

export default withRouter(CreateChatComponent);
